
































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import FieldData from '@/components/infrastructures/functions/fieldData';
import authService from '@/components/domains/authorization/authService';
import { User } from '@/components/domains/authorization/user';
import PrimaryBtn from '@/components/infrastructures/atoms/designed/PrimaryBtn.vue';
import SubBtn from '@/components/infrastructures/atoms/designed/SubBtn.vue';
import GeneralField from '@/components/infrastructures/atoms/GeneralField.vue';
import KawaiiDialog from '@/components/infrastructures/atoms/KawaiiDialog.vue';
import HpSubTitle from '@/components/infrastructures/atoms/text/HpSubTitle.vue';
import HpText from '@/components/infrastructures/atoms/text/HpText.vue';
import HpTitle from '@/components/infrastructures/atoms/text/HpTitle.vue';
import {
  formatRetireDate,
  isEmailLike,
  LoginScreen,
  loginScreen,
  RESEND_COOLDOWN_SECONDS,
} from '@/components/domains/account/passwordless/authPolicy';
import PasswordlessService, {
  errorMessage,
  errorReason,
  FALLBACK_ERROR,
  loadAuthPolicy,
} from '@/components/domains/account/passwordless/passwordlessService';

@Component({
  components: {
    HpTitle,
    HpText,
    HpSubTitle,
    GeneralField,
    KawaiiDialog,
    SubBtn,
    PrimaryBtn,
  },
})
export default class LoginForm extends Vue {
  // =========================
  // データ
  // =========================
  name = 'LoginForm';

  /** メールアドレス入力 */
  mailAddress = new FieldData()
      .withId('mailAddress')
      .withType('text_field')
      .withLabel(this.$t('メールアドレス').toString());

  /** パスワード入力 */
  password = new FieldData()
      .withId('password')
      .withType('password')
      .withLabel(this.$t('パスワード').toString());

  /** ダイアログ制御 */
  showDialog = false;
  dialogMessage = '';

  /** ご要望のフラグ */
  flg = false;

  /** 表示する内容（/auth/policy から。読み込み中は null） */
  screen: LoginScreen | null = null;
  retireDate = '';
  passwordOpen = false;

  /** メールでログイン */
  phase: 'form' | 'sent' = 'form';
  magicEmail = '';
  sentTo = '';
  magicError = '';
  magicInfo = '';
  sending = false;
  cooldown = 0;
  private cooldownTimer: number | null = null;

  mounted() {
    // ログイン画面を開くたびに取り直す。失敗・404・4 秒経過ならこれまでの画面。
    loadAuthPolicy({fresh: true}).then((policy) => {
      this.screen = loginScreen(policy);
      this.retireDate = formatRetireDate(this.screen.passwordRetiresAt);
    });
  }

  beforeDestroy() {
    this.stopCooldown();
  }

  // =========================
  // ウォッチャ
  // =========================
  /**
   * showDialog が ON ➔ flg=true
   * showDialog が OFF ➔ キャッシュ無効リロード
   */
  @Watch('showDialog')
  onShowDialog(val: boolean) {
    if (val) {
      this.flg = true;
    } else {
      // location.reload(true) は非推奨のため、
      // タイムスタンプ付き URL でキャッシュバイパス
      window.location.replace(`${location.pathname}?_=${Date.now()}`);
    }
  }

  // =========================
  // メソッド
  // =========================
  /**
   * ログイン処理
   */
  async login() {
    try {
      await authService.login(this.mailAddress.value, this.password.value);
      this.$router.push('/mypage');
    } catch (e) {
      // パスワードでのログインが終了しているときは、バックエンドの文言をそのまま出す
      this.dialogMessage = errorReason(e) === 'PASSWORD_LOGIN_RETIRED'
          ? errorMessage(e, 'ログインに失敗しました。画面を更新してから再度お試しください。')
          : 'ログインに失敗しました。画面を更新してから再度お試しください。';
      this.showDialog = true; // ➔ ウォッチャが動く
    }
  }

  // ------------------------------------------------------------ メールでログイン

  private startCooldown() {
    this.stopCooldown();
    this.cooldown = RESEND_COOLDOWN_SECONDS;
    this.cooldownTimer = window.setInterval(() => {
      this.cooldown -= 1;
      if (this.cooldown <= 0) {
        this.stopCooldown();
      }
    }, 1000);
  }

  private stopCooldown() {
    if (this.cooldownTimer !== null) {
      window.clearInterval(this.cooldownTimer);
      this.cooldownTimer = null;
    }
    if (this.cooldown < 0) {
      this.cooldown = 0;
    }
  }

  private async send(address: string): Promise<boolean> {
    this.magicError = '';
    this.sending = true;
    try {
      await PasswordlessService.requestMagicLink(address);
      this.startCooldown();
      return true;
    } catch (e) {
      this.magicError = errorMessage(e, FALLBACK_ERROR);
      return false;
    } finally {
      this.sending = false;
    }
  }

  async sendMagicLink() {
    if (this.sending) {
      return;
    }
    this.magicInfo = '';
    const address = this.magicEmail.trim();
    if (address === '') {
      this.magicError = 'メールアドレスを入力してください。';
      return;
    }
    if (!isEmailLike(address)) {
      this.magicError = 'メールアドレスの形式が正しくありません。';
      return;
    }
    if (await this.send(address)) {
      this.sentTo = address;
      this.phase = 'sent';
    }
  }

  async resendMagicLink() {
    this.magicInfo = '';
    if (this.cooldown > 0 || this.sending) {
      return;
    }
    if (await this.send(this.sentTo)) {
      this.magicInfo = 'もう一度送りました。';
    }
  }

  changeAddress() {
    this.phase = 'form';
    this.magicError = '';
    this.magicInfo = '';
  }
}
